import Component from './Component'

export default class Popover extends Component {

	static _type = 'Popover'

	_target
	_content

	constructor (target, content, params = {}) {
		super(params)
		this._target = target
		this._content = content
	}

	tether() {
		super.tether()

		// Create the tooltip
		$(this._target).popover(Object.assign({
			html: true,
			content: this._content
		}, this.params))
	}

	destroy() {
		// Destroy the tooltip
		$(this._target).popover('dispose')
		this._target = null
		this._content = null

		super.destroy()
	}
}
